import type {
	Competition,
	CompetitionConfig,
	CompetitionsFilter,
	CurrentCompetitions,
	LeaderboardRecord
} from '$lib/types/leaderboard';
import { derived, writable, type Readable, type Writable } from 'svelte/store';
import competitions from './competitions';
import type { Level } from '$lib/types/tradingRewards';
import { currentSeasonObject } from '$lib/home/tradingRewards/store';
import persistentStorage from '$lib/persistentStorage';

//unused old variables
export const currentLeaderboard: Writable<CurrentCompetitions> = writable('shanghai');

export const currentLeaderboardConfig: Readable<Competition | undefined> = derived(
	[currentLeaderboard],
	([$currentLeaderboard]) => {
		if ($currentLeaderboard) {
			return competitions[$currentLeaderboard];
		} else {
			return undefined;
		}
	}
);

// leaderboard
export const loadingLeaderboard: Writable<boolean> = writable(false);
export const leaderboardRecords: Writable<Array<LeaderboardRecord> | undefined> = writable();

//competitions
export const loadingCurrentCompetitionConfig: Writable<boolean> = writable(false);
export const currentCompetitionConfig: Writable<CompetitionConfig | undefined> = writable();
export const currentCompetitionId: Writable<string | undefined> = persistentStorage(
	'currentCompetitionId',
	undefined
);
export const competitionLevelSelected: Writable<Level | undefined> = writable(undefined);

export const loadingUserCompetitionStats: Writable<boolean> = writable(false);
export const userCurrentCompetitionStats: Writable<LeaderboardRecord | undefined> = writable();

export const competitionsFilter: Writable<CompetitionsFilter> = writable('All');
